import React from 'react';
import {Col, Row, Button} from "react-bootstrap";
import style from './AboutUs.module.scss';
import {connect} from "react-redux";
import * as pageActions from "../../../../redux/action/page.action";
import history from "../../../../helper/history";

class AboutUs extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      summary: ''
    }
  }

  async componentDidMount() {
    const response = await this.props.fetchPagesByKey('why');
    this.setState({summary: response.summary})
  }

  redirect() {
    history.push(`/why`);
  }

  render() {
    return (
      <div>
        <h2 className={'section-title'}>چرا هوم پلاک؟</h2>
        <Row className={'justify-content-center'}>
          <Col xs={12} className={'text-right'}>
            <span className={`d-inline-block quill text-center text-md-right ${style.description}`}>
              {this.state.summary}
            </span>
            <div className={'text-md-right text-center mt-5'}>
              <Button className={`${style.more}`} onClick={() => {
                this.redirect();
              }}>اطلاعات بیشتر</Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  fetchPagesByKey: (key) => dispatch(pageActions.fetchPagesByKey(key))
});

export default connect(mapStateToProps, mapDispatchToProps)(AboutUs);
